import { api } from './authService';
import ConfigManager from '../utils/configManager';

class LdapService {
  constructor() {
    this.baseURL = ConfigManager.getApiBaseUrl();
  }

  async getLdapStatus() {
    try {
      const response = await api.get('/auth/ldap-status');
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('LDAP status check failed:', error.message);
      
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to check LDAP status',
        data: {
          ldapEnabled: false,
          ldapUrls: '',
          ldapBase: ''
        }
      };
    }
  }

  async testLdapConnection() {
    try {
      const response = await api.post('/auth/ldap-test');
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('LDAP connection test failed:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to test LDAP connection'
      };
    }
  }

  // Parse LDAP server information for display
  formatLdapServers(ldapUrls) {
    if (!ldapUrls) return [];
    
    return ldapUrls.split(',').map(url => {
      const trimmed = url.trim();
      const match = trimmed.match(/ldap:\/\/([^:]+):?(\d+)?/);
      if (match) {
        return {
          server: match[1],
          port: match[2] || '389',
          url: trimmed
        };
      }
      return { server: trimmed, port: '389', url: trimmed };
    });
  }

  // Format LDAP base DN for display
  formatBaseDn(baseDn) {
    if (!baseDn) return '';
    
    return baseDn
      .split(',')
      .map(part => part.trim())
      .map(part => {
        if (part.startsWith('dc=')) {
          return part.substring(3);
        }
        return part;
      })
      .join('.');
  }
}

const ldapService = new LdapService();
export default ldapService;
